<template>
  <div class="ph-compare-page">
    <top-bar title="Product Comparison" :rightTxt="'Class'" :showEdit="true" @toEdit="toCategory"></top-bar>
    <action-bar @showAddProduct="showAddProduct" @showSearch="showSearch" :add="true"></action-bar>

    <div class="ph-compare-table" v-if="column.length > 0 && list.length > 0">
      <div class="ph-compare-container">
        <div class="table-row" v-for="(col, rowIndex) in column" :key="rowIndex">
          <div class="fixed-column-cell" :class="{ 'center': col.is_center }">
            <div>{{col.label}}</div>
          </div>

          <div class="scrollable-products-wrapper">
            <div
                class="product-cell"
                v-for="(item, pIndex) in list"
                :key="pIndex"
                :style="{backgroundColor: item.compare_color || '#f5f5f5'}"
            >
              <div class="product-name" v-if="rowIndex === 0">
                <div class="close" @click="removeCompareProduct(pIndex)">
                  <img :src="icons.close" alt="">
                </div>
                <div class="image">
                  <img :src="item.compare_image" alt="">
                </div>
                <div class="title">{{item.name}}</div>
              </div>

              <div class="category-name" v-else-if="rowIndex === 1">{{item.compare_category ? item.compare_category.en_name : '-'}}</div>

              <template v-else-if="item.parameter">
                <template v-for="parameter in item.parameter">
                  <div v-if="parameter.is_check == 1 && parameter.attr_id == col.value" class="empty-cell">
                    <img :src="icons.confirm" alt="">
                  </div>
                  <div
                      class="txt"
                      :class="{ 'not-center': !parameter.is_center }"
                      v-else-if="parameter.value && parameter.attr_id == col.value"
                  >{{parameter.value}}</div>
                  <div v-else-if="parameter.is_check == 0 && parameter.attr_id == col.value" class="empty-cell">
                    <img :src="icons.empty" alt="">
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="empty-state" v-else>-->
    <!--      <p>暂无对比产品</p>-->
    <!--      <div class="add-btn-large" @click="showAddProduct">-->
    <!--        <span>+</span>-->
    <!--        <span>添加产品进行对比</span>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import actionBar from './components/action-bar.vue'
import topBar from './components/top-bar.vue'

export default {
  name: 'PhTable',
  components: {
    actionBar,
    topBar
  },
  props: {
    column: {
      type: Array,
      default: function () {
        return []
      }
    },
    list: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      icons: {
        close: process.env.VUE_APP_BASE_URL + '/assets/img/close.png',
        empty: process.env.VUE_APP_BASE_URL + '/assets/img/x.png',
        confirm: process.env.VUE_APP_BASE_URL + '/assets/img/g.png'
      }
    }
  },
  mounted() {

  },
  methods: {
    toCategory(){
      this.$router.push('/ph/compare/category')
    },
    showAddProduct() {
      this.$router.push('/ph/compare/add')
    },

    showSearch() {
      this.$router.push('/ph/compare/list')
    },

    removeCompareProduct(index) {
      this.$emit('removeCompareProduct', index)
    }
  }
}
</script>

<style scoped>
/* 页面容器 */
.ph-compare-page {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding: 0;
  margin: 0;
  font-size: 0.28rem;
  color: #333;
  margin-top: 0.9rem;
}

/* 对比表格 */
.ph-compare-table {
  font-size: 0.28rem;
  width: 100%;
  position: relative;
  overflow-x: auto;
  display: flex;
  margin-top: 0.26rem;
  margin-bottom: 0.65rem;
  -webkit-overflow-scrolling: touch;
}

/* 滚动条样式 */
.ph-compare-table::-webkit-scrollbar {
  display: none;
}

.ph-compare-table {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.ph-compare-container {
  min-width: 100%;
  display: inline-block;
}

/* 每一行 */
.table-row {
  display: flex;
  align-items: stretch;
}

/* 左侧固定列标题单元格 */
.fixed-column-cell {
  position: sticky;
  left: 0;
  z-index: 10;
  flex: 0 0 1.6rem;
  width: 1.6rem;
  padding: 0.15rem 0.1rem;
  box-sizing: border-box;
  font-weight: 500;
  font-size: .24rem;
  display: flex;
  align-items: flex-start;
  background-color: #ffffff;
  padding-left: .32rem;
  padding-top: .2rem;
}

.fixed-column-cell.center {
  align-items: center;
}

.fixed-column-cell > div {
  width: 100%;
  text-align: left;
}

/* 右侧产品数据容器 */
.scrollable-products-wrapper {
  display: flex;
}

/* 单个产品单元格 */
.product-cell {
  width: 2.55rem;
  margin-left: 0.23rem;
  padding: 0.15rem 0.1rem;
  box-sizing: border-box;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.product-cell .image {
  width: 100%;
}

.product-cell .image img {
  display: block;
  width: 100%;
}

/* 产品型号样式 */
.product-name {
  font-weight: bold;
  font-size: 0.32rem;
  width: 100%;
  padding-top: .2rem;
}

/* 分类样式 */
.category-name {
  font-size: 0.24rem;
  width: 100%;
}

/* 参数值样式 */
.scrollable-products-wrapper .product-cell .txt {
  white-space: pre-wrap;
  word-break: break-word;
  width: 100%;
  font-size: .24rem;
}

.scrollable-products-wrapper .product-cell .txt.not-center {
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 首行圆角 */
.table-row:first-child .scrollable-products-wrapper .product-cell {
  border-top-left-radius: 0.1rem;
  border-top-right-radius: 0.1rem;
}

/* 末行圆角 */
.table-row:last-child .scrollable-products-wrapper .product-cell {
  border-bottom-left-radius: 0.1rem;
  border-bottom-right-radius: 0.1rem;
}

/* 删除按钮 */
.scrollable-products-wrapper .product-cell .product-name .close {
  position: absolute;
  width: 0.4rem;
  right: 0;
  top: 0;
  display: block;
  cursor: pointer;
}

.scrollable-products-wrapper .product-cell .product-name .close img {
  display: block;
  width: 100%;
}

.scrollable-products-wrapper .product-cell .product-name .title {
  margin-top: 0.1rem;
  font-size: .26rem;
  font-weight: 500;
}

.scrollable-products-wrapper .product-cell .empty-cell {
  width: 0.4rem;
}

.scrollable-products-wrapper .product-cell .empty-cell img {
  display: block;
  width: 100%;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0.32rem;
  text-align: center;
}

.empty-state p {
  font-size: 0.32rem;
  color: #999;
  margin-bottom: 0.4rem;
}

.add-btn-large {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.16rem;
  padding: 0.4rem 0.8rem;
  background: #f5f5f5;
  border-radius: 0.16rem;
  cursor: pointer;
}

.add-btn-large span:first-child {
  font-size: 0.6rem;
  color: #e62129;
  font-weight: 600;
}

.add-btn-large span:last-child {
  font-size: 0.28rem;
  color: #666;
}

/* 滚动条样式 */
.ph-compare-table::-webkit-scrollbar {
  height: 0.08rem;
}

.ph-compare-table::-webkit-scrollbar-track {
  background: #f0f0f0;
}

.ph-compare-table::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 0.04rem;
}

.ph-compare-table::-webkit-scrollbar-thumb:hover {
  background: #999;
}
</style>
